import { Component, OnInit } from '@angular/core';
import { ChartType, LegendItem, LbdChartComponent } from '../lbd/chart/chart.component';
import * as Chartist from 'chartist';

import { StatusMonitorUpdate } from '../services/status-monitor.service';
import { StatusHistoryService } from '../services/status-history.service';

type ChartSerie = Array<number>;

class ChartData {
  readonly series: Array<ChartSerie>;
  readonly labels: Array<string>;

  constructor() {
    this.series = new Array<ChartSerie>();
    this.labels = new Array<string>();
  }
}

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {

  chartType: ChartType;
  chartData: ChartData;
  chartOptions: any;
  chartResponsive: any[];
  chartLegendItems: LegendItem[];

  pointCount = 0;

  constructor(
    private statusHistory: StatusHistoryService
  ) { }

  ngOnInit() {
    this.chartType = ChartType.Line;
    this.chartOptions = {
      low: 0,
      high: 50,
      showArea: true,
      height: '245px',
      axisX: {
        showGrid: false,
      },
      lineSmooth: Chartist.Interpolation.simple({
        divisor: 3
      }),
      showLine: false,
      showPoint: false,
    };
    this.chartLegendItems = [
      { title: 'Válaszidő milliszekundumban (ms)', imageClass: 'fa fa-circle text-info' },
      { title: 'Internet kimaradás', imageClass: 'fa fa-circle text-danger' }
    ];

    this.updateChart();

    this.statusHistory.updated.subscribe(() => {
      this.updateChart();
    });
  }

  updateChart() {
    const newData = new ChartData();
    let max = 10;

    if (this.statusHistory.data.length > 0) {
      const lathencySerie = this.statusHistory.data.map((item, id, arr) => {
        if (id % 3 === 0) {
          newData.labels.push(`${item.end.getHours()}:${item.end.getMinutes()}:${item.end.getSeconds()}`);
        } else {
          newData.labels.push('');
        }

        if (max < item.duration + 10) {
          max = item.duration + 10;
        }

        return item.duration;
      }) as ChartSerie;

      const errorSerie = this.statusHistory.data.map((item, id, arr) => {
        if (item.success) {
          return 0;
        } else {
          return max;
        }
      }) as ChartSerie;

      newData.series.push(lathencySerie);
      newData.series.push(errorSerie);
    }

    this.chartData = newData;
    this.chartOptions.high = max;
  }

}



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/history/history.component.ts